import { ClassProvider, FactoryProvider, InjectionToken, Injectable } from "@angular/core";

// TODO: eslint fix
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function _window(): any {
	return window;
}

export const WINDOW = new InjectionToken("WindowToken");

export abstract class WindowRef {
	public get nativeWindow(): Window {
		throw new Error("Not implemented.");
	}
}

@Injectable({ providedIn: "root" })
export class BrowserWindowRef extends WindowRef {
	public get nativeWindow(): Window {
		return _window();
	}
}

export const browserWindowProvider: ClassProvider = {
	provide: WindowRef,
	useClass: BrowserWindowRef
};
export const windowProvider: FactoryProvider = {
	provide: WINDOW,
	useFactory: _window,
	deps: []
};
export const WINDOW_PROVIDERS = [browserWindowProvider, windowProvider];
